export default __webpack_public_path__ + "static/media/Logo3.310254e6.png";